import { ApiEndpoints } from "@shared/api/api-endpoints";
import { cxApiClient, mxApiClient } from "@shared/api/clients/apiClientFactory";

export const allAccountsApi = {
  getConsumerConsumptionKpi: async (params: {
    remote_utility_id: string | number;
    consumer_no: string;
    utility_service?: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "mx",
      "consumer-consumption-kpi",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("consumer_no", params.consumer_no);
        if (params.utility_service) {
          qs.push("utility_service", params.utility_service);
        }
      }
    );
    const response = await mxApiClient.get(url);
    return response.data?.result;
  },

  getConsumerMonthlyConsumption: async (params: {
    remote_utility_id: string | number;
    consumer_no: string;
    no_of_months: string | number;
    utility_service?: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "mx",
      "consumer-monthly-consumption",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("consumer_no", params.consumer_no);
        qs.push("no_of_months", params.no_of_months);
        if (params.utility_service) {
          qs.push("utility_service", params.utility_service);
        }
      }
    );
    const response = await mxApiClient.get(url);
    return response.data?.result;
  },
};
